import useSharedStepFlow from "src/hooks/useStepFlow";
import { JOURNEY_DETAILS_STEPS } from "../constants/JourneyDetails";
import { useJourneyDynamicDetails } from "../Pages/JourneyDetails/context";

export default function useStepFlow() {
  const { validityState } = useJourneyDynamicDetails();
  return useSharedStepFlow({ steps: JOURNEY_DETAILS_STEPS, validityState });
}
